<div class="signer-list">
  <div class="signer-item" *ngFor="let signer of signerList; let i = index" [ngClass]="{'bordered-signer-item': i !== signerList.length - 1}">
    <div class="row">
      <div class="col-1">
        <img *ngIf="!signer.signed" src="../../../assets/icons/DESKTOP/ic_done_all_24px.png" alt="">
        <img *ngIf="signer.signed" src="../../../assets/icons/DESKTOP/ic_done_all_-1.png" alt="">
      </div>
      <div class="col">
        <span class="f-16">{{signer.fullName}}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-1"></div>
      <div class="col">
        <span class="f-12">{{signer.email}}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-1"></div>
      <div class="col">
        <span class="f-10 f-opacited" *ngIf="!signer.signed">
          {{i18n.SIGNATURE.PENDENTE}}
        </span>
        <span class="f-10 f-blue upper-case" *ngIf="signer.signed">
          {{i18n.SIGNATURE.ASSINOU_COMO_UPERCASE}} {{signer?.type}}
        </span>
      </div>
    </div>
  </div>
</div>